import { render, staticRenderFns } from "./SetCentre.vue?vue&type=template&id=335d1d81"
import script from "./SetCentre.vue?vue&type=script&lang=js"
export * from "./SetCentre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports